module.exports = __webpack_public_path__ + "media/images/bellevue_logo-7fad4b53a75c4e9af2da590f2fc15e39.png";